export const userNamesList = [
  "@PacketPusher42",
  "@ScamMaster3000",
  "@URL_inspector",
  "@DataDiva",
  "@Jan123",
  "@PhishingExpert",
  "@Techie_007",
  "@catlover_1997",
  "@jandevries",
  "@ilovecats1234",
  "@Ali_1985",
  "@OskarDeJager",
  "@Koffieleut72",
  "@SanneRijdt",
  "@TommyOnTheGo",
  "@Eva_OpDeTrekker",
  "@AnitaVoordeel",
  "@SarahVanDijk",
  "@Janet23",
  "Fietser1994",
  "@Ingrid_klopt",
];
